<template>
  <div class="mb-2 result w-100">
    <div class="media-body">
      <b-button
        class="mb-1 ml-1 float-right"
        size="sm"
        variant="secondary"
        v-if="result.sem_record_type != 'medicine'"
        v-on:click.prevent="openDetail()"
      >
        Details
      </b-button>

      <b-button
        target="_blank"
        class="mb-1 ml-1 float-right"
        size="sm"
        variant="light"
        v-if="result.sem_record_type == 'medicine'"
        :href="result.sem_url"
      >
        Open link
      </b-button>

      <b-button
        class="mb-1 ml-1 float-right"
        size="sm"
        variant="primary"
        v-on:click.prevent="openGraph(result.sem_encoded_id, result.sem_title)"
      >
        <b-icon icon="diagram-2" font-scale="1.2" variant="white"></b-icon>
        Graph
      </b-button>

      <span v-if="result.eligible_countries_ss" class="float-right mr-3 ml-3">
        <span class="eligibility-label mr-2">Eligibility</span>
        <b-badge
          variant="warning"
          class="float-right mr-1"
          v-for="(x, i) in result.eligible_countries_ss.slice().reverse()"
          :key="'ec' + i"
          v-b-popover.hover.top="{
            title: 'Eligible countries',
            content:
              '<b>M:</b> Member states<br><b>E:</b> EEA countries<br><b>A:</b> Associated countries<br><b>S:</b> Selected countries<br><b>T:</b> Third countries<br><br><b>Be aware: </b>Information about the eligibility of associated and third countries is determined by rule-based techniques on calls from 2021 onwards and may be inaccurate.<br><br> Please review the <b>Conditions</b> for certainty.',
            html: true,
          }"
        >
          {{ x.charAt(0) }}
        </b-badge>
      </span>

      <h4 class="media-heading">
        <b-badge variant="success" class="mr-2" v-if="topicVisited"
          >Visited</b-badge
        >
        <!--
        <b-badge
          variant="info"
          class="mr-2"
          v-if="result.action_statuses && result.action_statuses.length > 0"
        >
          {{ result.action_statuses[result.action_statuses.length - 1] }}
        </b-badge>
        -->
        <b-badge variant="info" class="mr-2" v-if="result.topic_status_s">
          {{ result.topic_status_s }}
        </b-badge>

        <a v-if="result.sem_title" v-on:click.prevent="openDetail()">{{
          result.sem_title
        }}</a>
        <a v-else v-on:click.prevent="openDetail()">{{ result.sem_url }}</a>
      </h4>

      <div class="w-100">
        <span v-if="result.sem_record_type == 'medicine'">
          Type:
          <b-badge variant="secondary">
            medicine
          </b-badge>
        </span>
        <b-row>
          <b-col cols="6">
            <span
              v-for="prop in props1"
              :key="prop.key"
              v-show="result[prop.key]"
            >
              {{ prop.name }}:
              <b-badge v-if="prop.type == 'string'" variant="white">
                {{ result[prop.key] | truncate(50, "...") }}
              </b-badge>
              <b-badge v-if="prop.type == 'date'" variant="white">
                {{ result[prop.key] | moment("DD. MMM YYYY // hh:mm") }}
              </b-badge>
              <span v-if="prop.type == 'array'">
                <b-badge
                  v-for="(x, index) in result[prop.key]"
                  variant="white"
                  class="mr-1"
                  :key="result.id + '-' + prop.key + '-' + index + '-' + x"
                  >{{ x }}</b-badge
                >
              </span>
              <span v-if="prop.type == 'datearray'">
                <b-badge
                  v-for="(x, index) in result[prop.key]"
                  variant="white"
                  class="mr-1"
                  :key="result.id + '-' + prop.key + '-' + index + '-' + x"
                >
                  {{ x | moment("DD MMMM YYYY") }}
                </b-badge>
              </span>
              <br />
            </span>
          </b-col>
          <b-col cols="6">
            <span
              v-for="prop in props2"
              :key="prop.key"
              v-show="result[prop.key]"
            >
              {{ prop.name }}:
              <b-badge v-if="prop.type == 'string'" variant="white">
                {{ result[prop.key] | truncate(50, "...") }}
              </b-badge>
              <b-badge v-if="prop.type == 'date'" variant="white">
                {{ result[prop.key] | moment("DD. MMM YYYY // hh:mm") }}
              </b-badge>
              <span v-if="prop.type == 'array'">
                <b-badge
                  v-for="(x, index) in result[prop.key]"
                  variant="white"
                  class="mr-1"
                  :key="result.id + '-' + prop.key + '-' + index + '-' + x"
                  >{{ x }}</b-badge
                >
              </span>
              <span v-if="prop.type == 'datearray'">
                <b-badge
                  v-for="(x, index) in result[prop.key]"
                  variant="white"
                  class="mr-1"
                  :key="result.id + '-' + prop.key + '-' + index + '-' + x"
                >
                  {{ x | moment("DD MMMM YYYY") }}
                </b-badge>
              </span>
              <br />
            </span>
          </b-col>
        </b-row>
      </div>
      <div class="description">
        <p v-if="result.sem_excerpt" class="highlighting">
          <span v-html="result.sem_excerpt"></span>
        </p>

        <div
          v-else-if="result.description && result.description.length > 12"
          :inner-html.prop="result.description | truncate(500, '...')"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "result",
  props: ["result"],
  components: {},
  data() {
    return {
      props1: [
        { key: "frameworkProgramme", name: "Programme", type: "string" },
        { key: "callTitle", name: "Call", type: "string" },
        { key: "id", name: "Topic ID", type: "string" },
      ],
      props2: [
        {
          key: "action_plannedOpeningDates",
          name: "Opening date",
          type: "datearray",
        },
        { key: "action_deadlineDates", name: "Deadline", type: "array" },
        { key: "action_types", name: "Action types", type: "array" },
      ],
    };
  },
  filters: {
    truncate: function(text, length, suffix) {
      if (text && text.length > length)
        return text.substring(0, length) + suffix;
      else return text;
    },
  },
  methods: {
    openGraph(nodeId, nodeTitle) {
      this.$router.push({
        name: "visualization",
        query: { id: nodeId },
        params: { nodeTitle: nodeTitle },
      });
    },
    openDetail() {
      this.$router.push({ path: "/detail/" + this.result.sem_encoded_id });
    },
  },
  computed: {
    topicVisited() {
      if (this.$store.state.visitedTopics) {
        return (
          this.$store.state.visitedTopics.indexOf(this.result.sem_encoded_id) >
          -1
        );
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.eligibility-label {
  font-size: 75%;
  font-weight: 500;
  vertical-align: super;
}
.description {
  background-color: #fafafa;
  border-radius: 5px;
  border: 1px solid #eee;
  padding: 15px 15px 10px 15px;
  margin-top: 10px;
}
</style>
